const CURRENT_MONTH = (new Date(Date.now())).getMonth()
const CURRENT_YEAR = (new Date(Date.now())).getFullYear()
const CURRENT_DAY = (new Date(Date.now())).getDate()
const ANIMATE_DURATION = 250
const ANIMATE_DURATION_SWIPE = 1000
const SWIPE_PER_CLICK = 8
let CURRENT_DATE = new Date(CURRENT_YEAR, CURRENT_MONTH, CURRENT_DAY)
let date = new Date(CURRENT_YEAR, CURRENT_MONTH, CURRENT_DAY)
let swipeValue
let miniCalendarWidth = 186
let RIGHT_RANGE
let calendar
let calendarMarginLeft
let nextButton
let prevButton
let visiblePartOfCalendarWidth
let miniCalendar
let miniCalendarMarginLeft = 30
let firstDayInFilter = CURRENT_DATE
let secondDayInFilter = CURRENT_DATE
let filterDatePeriod = null
const miniCalendarContainer = `
    <div class="miniCalendarWrapper">
        <div id="miniCalendar" class="miniCalendarContainer btn btn-outline-secondary">
            <div>Календарь</div>
            <div>
                <span class=" svg-mask" style=" mask-image: url(/resources/img/horizontal-calendar/next.svg); height: 12px; width: 6px;"></span>
            </div>
        </div>
    </div>
`

let horizontalCalendarModule = {
  clickCounter: 0, period: [], initialData: [], createCalendar: function (element) {
    let item = ''
    let monthEnd = new Date(CURRENT_YEAR, date.getMonth() + 3, CURRENT_DAY)
    do {
      const isFirstDayOrCurrentDate = date.getDate() === 1 || date.toString() === CURRENT_DATE.toString()
      if (isFirstDayOrCurrentDate) {
        item += `
                    <div class="calendar-container_month">
                        <div class="calendar-container_month-name" data-data="${date.getMonth()}">
                            ${this.getMonthsName(date.getMonth())}
                        </div>
                        <div class="calendar-container_items">
                `
      }

      const isWeekend = this.getWeekDay(date) === 'вс' || this.getWeekDay(date) === 'сб'
      item += `
                <div class="calendar-container_item_wrapper">
                    <div class="calendar-container_item" onclick="horizontalCalendarModule.handleDayClick(event)" data-data="${date}">
                        <div class="calendar-wrapper_item">
                            <div class="calendar-container_item-day">${date.getDate()}</div>
                            <div class="calendar-container_item-title ${isWeekend ? 'week_day_color' : ''}">
                                ${this.getWeekDay(date)}
                            </div>
                        </div>
                    </div>
                </div>
            `

      if (this.getLastDayOfMonth(date.getFullYear(), date.getMonth()) === date.getDate()) {
        item += `
                        </div>
                    </div>
                `
      }

      date.setDate(date.getDate() + 1)
    } while (date.getMonth() !== monthEnd.getMonth())

    date = new Date(CURRENT_YEAR, CURRENT_MONTH, CURRENT_DAY)

    element.innerHTML = `
            <div class="calendar-wrapper">
                <div id="horizontal-calendar_prevButton" onClick="horizontalCalendarModule.prevWithThrottle()"></div>
                <div class="calendar-container">
                    <div class="calendar-container_inner">
                        ${item}
                        ${miniCalendarContainer}
                    </div>
                </div>
                <div id="horizontal-calendar_nextButton" onClick="horizontalCalendarModule.nextWithThrottle()"></div>
            </div>
        `
  }, throttle: function (func, ms) {
    let isThrottled = false, savedArgs, savedThis

    function wrapper () {
      if (isThrottled) {
        savedArgs = arguments
        savedThis = this
        return
      }
      func.apply(this, arguments)
      isThrottled = true
      setTimeout(function () {
        isThrottled = false
        if (savedArgs) {
          wrapper.apply(savedThis, savedArgs)
          savedArgs = savedThis = null
        }
      }, ms)
    }

    return wrapper
  }, next: function () {
    calendarMarginLeft = window.getComputedStyle(calendar).left
    $(prevButton).show()
    visiblePartOfCalendarWidth = $('.calendar-container')[0].clientWidth
    RIGHT_RANGE = calendar.offsetWidth - visiblePartOfCalendarWidth + nextButton.offsetWidth - prevButton.offsetWidth + miniCalendarMarginLeft
    let pixelToButton = $(nextButton).offset()
    if (parseInt(calendarMarginLeft) - swipeValue < pixelToButton.left) {
      if (parseInt(calendarMarginLeft) - swipeValue <= -RIGHT_RANGE) {
        $(calendar).animate({
          left: `-${RIGHT_RANGE + miniCalendarWidth - nextButton.offsetWidth - prevButton.offsetWidth + (miniCalendarMarginLeft * 2)}`
        }, ANIMATE_DURATION)
        $(miniCalendar).show(ANIMATE_DURATION)
        $(nextButton).hide()
        return
      }
      $(calendar).animate({
        left: parseInt(calendarMarginLeft) - swipeValue
      }, ANIMATE_DURATION)
    }
  }, nextWithThrottle: function () {
    horizontalCalendarModule.throttle(horizontalCalendarModule.next, ANIMATE_DURATION)()
  }, prev: function () {
    calendarMarginLeft = parseInt(window.getComputedStyle(calendar).left)
    $(miniCalendar).hide(ANIMATE_DURATION)
    $(nextButton).show()

    if (calendarMarginLeft === 0 || calendarMarginLeft === -swipeValue) {
      $(prevButton).hide()
    }
    if (calendarMarginLeft + swipeValue > 0) {
      $(calendar).animate({ left: 0 }, ANIMATE_DURATION)
      $(prevButton).hide()
      return
    }
    if (calendarMarginLeft + swipeValue <= 80) {
      $(calendar).animate({ left: calendarMarginLeft + swipeValue }, ANIMATE_DURATION)
    }
  }, prevWithThrottle: function () {
    horizontalCalendarModule.throttle(horizontalCalendarModule.prev, ANIMATE_DURATION)()
  }, getWeekDay: function (date) {
    const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']
    return days[date.getDay()]
  }, getMonthsName: function (monthsNumber) {
    const nameOfMonths = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',]
    return nameOfMonths[monthsNumber]
  }, getLastDayOfMonth: function (year, month) {
    let date = new Date(year, month + 1, 0)
    return date.getDate()
  }, dateDiffInDays: function (date1, date2) {
    return Math.ceil(Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) + 1
  }, handleDayClick: function (event) {
    let node = event.currentTarget
    if ($(node).hasClass('active')) {
      this.unActivatedAllDay()
      this.clearRangeStyleActiveDay()
      this.clickCounter = 0
      miniCalendarModule.dateFrom = null
      miniCalendarModule.dateTo = null
      submitHomeGridDateFilter(null, null)
      this.initAllDaysFromApi()
      return
    }
    $(node).addClass('active')
    this.clickCounter++

    if (this.clickCounter === 1) {
      firstDayInFilter = new Date(node?.dataset?.data)
      filterDatePeriod = null
    }

    if (this.clickCounter === 2) {
      secondDayInFilter = new Date(node?.dataset?.data)
      this.makeRangeStyleActiveDay(this.getActiveDayIndex())
      let data = [firstDayInFilter, secondDayInFilter].sort((a, b) => {
        return new Date(a) - new Date(b)
      })
      this.clickCounter = 0
      filterDatePeriod = this.dateDiffInDays(secondDayInFilter, firstDayInFilter)
      firstDayInFilter = data[0]
      secondDayInFilter = data[1]

    }

    if (filterDatePeriod) {
      let dateFrom = `${firstDayInFilter.getFullYear()}_${firstDayInFilter.getMonth() + 1}_${firstDayInFilter.getDate()}`
      let dateTo = `${secondDayInFilter.getFullYear()}_${secondDayInFilter.getMonth() + 1}_${secondDayInFilter.getDate()}`
      miniCalendarModule.dateFrom = dateFrom
      miniCalendarModule.dateTo = dateTo
      submitHomeGridDateFilter(dateFrom, dateTo)
    } else {
      let dateFrom = `${firstDayInFilter.getFullYear()}_${firstDayInFilter.getMonth() + 1}_${firstDayInFilter.getDate()}`
      let dateTo = dateFrom
      miniCalendarModule.dateFrom = dateFrom
      miniCalendarModule.dateTo = dateTo
      submitHomeGridDateFilter(dateFrom, dateTo)
    }
    if (this.clickCounter === 1) {
      filterDatePeriod = null
      this.unActivatedAllDay()
      this.clearRangeStyleActiveDay()
      $(node).addClass('active')
    }
  }, getActiveDayIndex: function () {
    let allDayItems = $('.calendar-container_item')
    let activeIndex = []
    for (let i = 0; i < allDayItems.length; i++) {
      if ($(allDayItems[i]).hasClass('active')) {
        activeIndex.push(i)
      }
    }
    return activeIndex
  }, clearRangeStyleActiveDay: function () {
    let allDayItems = $('.calendar-container_item')
    for (let i = 0; i < allDayItems.length; i++) {
      if ($(allDayItems[i]).hasClass('range')) {
        $(allDayItems[i]).removeClass('range')
      }
      if ($(allDayItems[i]).hasClass('firstIndex')) {
        $(allDayItems[i]).removeClass('firstIndex')
      }
      if ($(allDayItems[i]).hasClass('secondIndex')) {
        $(allDayItems[i]).removeClass('secondIndex')
      }
    }

    let containerItemWrapper = $('.calendar-container_item_wrapper')

    for (let i = 0; i < containerItemWrapper.length; i++) {
      if ($(containerItemWrapper[i]).hasClass('range-firs-day')) {
        $(containerItemWrapper[i]).removeClass('range-firs-day')
      }

      if ($(containerItemWrapper[i]).hasClass('range-last-day')) {
        $(containerItemWrapper[i]).removeClass('range-last-day')
      }
    }
  }, disableFilters: function (data) {
    let filterSide = $('.filter-body__left-side')

    if (data > 0) {
      filterSide.css('opacity', '1')
      filterSide.css('pointerEvents', 'all')
    } else {
      filterSide.css('opacity', '.5')
      filterSide.css('pointerEvents', 'none')
    }
  }, makeRangeStyleActiveDay: function (arr) {
    let allDayItems = $('.calendar-container_item')
    let [startIndex, endIndex] = arr
    for (let i = startIndex; i <= endIndex; i++) {
      $(allDayItems[i]).addClass('range')
    }

    let firstDayNode = $(`.calendar-container_item[data-data='${firstDayInFilter}']`)[0]
    let secondDayNode = $(`.calendar-container_item[data-data='${secondDayInFilter}']`)[0]

    if (new Date(firstDayNode.dataset.data) < new Date(secondDayNode.dataset.data)) {
      $(firstDayNode).addClass('firstIndex')
      $(secondDayNode).addClass('secondIndex')

      $(firstDayNode).parent().addClass('range-firs-day')
      $(secondDayNode).parent().addClass('range-last-day')
    } else {
      $(firstDayNode).addClass('secondIndex')
      $(secondDayNode).addClass('firstIndex')

      if ($('.secondIndex').hasClass('firstIndex') === false) {
        $(secondDayNode).parent().addClass('range-firs-day')
        $(firstDayNode).parent().addClass('range-last-day')
      }
    }

    let monthDiffValue = this.monthDiff(new Date(firstDayNode.dataset.data), new Date(secondDayNode.dataset.data))
    let target = $('.firstIndex')[0]
    let allMonthsItem = $('*.calendar-container_month')
    if (Math.abs(monthDiffValue) === 1) {
      $(target).parent().addClass('month-range')
    }
    if (Math.abs(monthDiffValue) === 2) {
      $(allMonthsItem[0]).addClass('month-range')
      $(allMonthsItem[1]).addClass('month-range')
    }
  }, unActivatedAllDay: function () {
    let allDayItems = $('.calendar-container_item')
    for (let i = 0; i < allDayItems.length; i++) {
      if ($(allDayItems[i]).hasClass('active')) {
        $(allDayItems[i]).removeClass('active')
      }
    }
    let allMonthsItem = $('.calendar-container_month')
    for (let i = 0; i < allMonthsItem.length; i++) {
      if ($(allMonthsItem[i]).hasClass('month-range')) {
        $(allMonthsItem[i]).removeClass('month-range')
      }
    }
  }, monthDiff: function (dateFrom, dateTo) {
    return dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
  }, paintDays: function (data) {
    let allDates = $('.calendar-container_item')
    for (let i = 0; i < allDates.length; i++) {
      let date2 = new Date($(allDates[i]).data().data)
      for (let j = 0; j < data.length; j++) {
        let date = new Date(data[j])
        if (date.getFullYear() === date2.getFullYear() && date.getMonth() === date2.getMonth() && date.getDate() === date2.getDate()) {
          $(allDates[i]).addClass('hasEvent')
          break
        }
      }
    }
  }, initAllDaysFromApi: function () {
    return $.ajax({
      url: `/home-page/date-all`,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      dataType: 'json',
      method: 'GET',
      success: function (data) {
        horizontalCalendarModule.paintDays(data)
        miniCalendarModule.paintDays(data)
        horizontalCalendarModule.period = data
        horizontalCalendarModule.disableFilters(data.items ? data.items.recordset.length ?? 1 : 1)
      },
    })
  }, getDateFromUrl: function () {
    let params = new URLSearchParams(window.location.search)
    return [params.get('dateFrom') || undefined, params.get('dateTo') || undefined]
  }, paintDaysFromUrlParams: function () {
    let [dateFromUrl, dateToUrl] = this.getDateFromUrl()
    if (!!dateFromUrl && !!dateToUrl) {
      let [yearFrom, monthFrom, dateFrom] = dateFromUrl.split('_')
      let [yearTo, monthTo, dateTo] = dateToUrl.split('_')
      let firstDay = $($(`*[data-data="${new Date(Number(yearFrom), Number(monthFrom - 1), Number(dateFrom))}"]`)[0])
      let lastDay = $($(`*[data-data="${new Date(Number(yearTo), Number(monthTo - 1), Number(dateTo))}"]`)[0])

      firstDay.addClass('active range firstIndex')
      firstDay.parent().addClass('range-firs-day')
      lastDay.addClass('active range secondIndex')
      lastDay.parent().addClass('range-last-day')
    }
  }, paintDaysFromUrlParamsMobile: function () {
    let [dateFromUrl, dateToUrl] = this.getDateFromUrl()
    if (!!dateFromUrl && !!dateToUrl) {
      let [yearFrom, monthFrom, dateFrom] = dateFromUrl.split('_')
      let [yearTo, monthTo, dateTo] = dateToUrl.split('_')
      $($(`*[data-data="${new Date(Number(yearFrom), Number(monthFrom - 1), Number(dateFrom))}"]`)[1]).addClass('mini-calendar__day-active')
      $($(`*[data-data="${new Date(Number(yearTo), Number(monthTo - 1), Number(dateTo))}"]`)[1]).addClass('mini-calendar__day-active')
    }
  }, clearAllHasEventDays: function () {
    let days = $('.hasEvent')
    for (let i = 0; i < days.length; i++) {
      $(days[i]).removeClass('hasEvent')
    }
  }, init: function () {
    calendar = $('.calendar-container_inner')[0]
    miniCalendar = $('#miniCalendar')[0]
    calendarMarginLeft = calendar.style.left
    nextButton = $('#horizontal-calendar_nextButton')[0]
    prevButton = $('#horizontal-calendar_prevButton')[0]
    visiblePartOfCalendarWidth = $('.calendar-container')[0].clientWidth
    RIGHT_RANGE = calendar.offsetWidth - visiblePartOfCalendarWidth - nextButton.offsetWidth - prevButton.offsetWidth
    $(prevButton).hide()
    $(miniCalendar).hide()
    swipeValue = RIGHT_RANGE / SWIPE_PER_CLICK

    this.paintDaysFromUrlParams()
    this.makeRangeStyleActiveDay(this.getActiveDayIndex())
    let [dateFromUrl, dateToUrl] = this.getDateFromUrl()
    if (!!dateFromUrl && !!dateToUrl) {
      let [yearFrom, monthFrom, dateFrom] = dateFromUrl.split('_')
      let [yearTo, monthTo, dateTo] = dateToUrl.split('_')
      let firstDay = $($(`*[data-data="${new Date(Number(yearTo), Number(monthTo - 1), Number(dateTo))}"]`)[0])
      let lastDay = $($(`*[data-data="${new Date(Number(yearFrom), Number(monthFrom - 1), Number(dateFrom))}"]`)[0])

      firstDay.removeClass('firstIndex')
      firstDay.parent().removeClass('range-firs-day')
      lastDay.removeClass('secondIndex')
      lastDay.parent().removeClass('range-last-day')

      horizontalCalendarModule.clickCounter = 0
    }

    const showMiniCalendar = (element) => {
      miniCalendarModule.initialStateInit(new Date())
      $(element).append(`<div id="mini-calendar"></div>`)
      let miniCalendar = document.getElementById('mini-calendar')
      $(miniCalendar).css({ 'display': 'none' })
      $(miniCalendar).fadeIn(miniCalendarModule.animationDuration, 'swing', () => {
        miniCalendarModule.init()
        this.paintDaysFromUrlParams()
        this.makeRangeStyleActiveDay(this.getActiveDayIndex())
        this.paintDaysFromUrlParamsMobile()
        miniCalendarModule.makeRangeStyleActiveDay(miniCalendarModule.getActiveDayIndex())
        miniCalendarModule.initialStateInit(new Date())
        miniCalendarModule.paintDays(horizontalCalendarModule.period)

        miniCalendarModule.addHideClickOutsideEventListener(miniCalendar)
        let [dateFromUrl, dateToUrl] = horizontalCalendarModule.getDateFromUrl()
        if (!!dateFromUrl && !!dateToUrl) {
          let [yearFrom, monthFrom, dateFrom] = dateFromUrl.split('_')
          let [yearTo, monthTo, dateTo] = dateToUrl.split('_')
          $($(`*[data-data="${new Date(Number(yearTo), Number(monthTo - 1), Number(dateTo))}"]`)[0]).removeClass('firstIndex')
          $($(`*[data-data="${new Date(Number(yearFrom), Number(monthFrom - 1), Number(dateFrom))}"]`)[0]).removeClass('secondIndex')
        }
        horizontalCalendarModule.clickCounter = 0
      })
    }

    const hideMiniCalendar = (element) => {
      $(element).fadeOut(miniCalendarModule.animationDuration, 'swing', () => {
        $(element).remove()
      })
    }

    $(miniCalendar).bind('click', () => {
      let miniCalendar = document.getElementById('mini-calendar')
      if (miniCalendar) {
        hideMiniCalendar(miniCalendar)
        return
      }
      showMiniCalendar($('#hiddenCalendar')[0])
      let elem = document.getElementById('mini-calendar')
      this.clearRangeStyleActiveDay()
      miniCalendarModule.createMiniCalendar(elem)
      // miniCalendarModule.initAllDaysFromApi();
      miniCalendarModule.paintDays(horizontalCalendarModule.period)
    })

    if ($(window).width() < 768) {
      $(nextButton).hide()
      $(prevButton).hide()
      $(miniCalendar).show()
      let endCoords = {}
      let xDown = null
      let yDown = null
      let swipeDiff

      let touchStartTime
      let touchEndTime
      let DT //delta time
      let DS //delta distance
      let V //speed

      let xDiff
      let prevXdiff

      $(calendar).on('touchstart', (event) => {
        DS = 0
        const touch = event.touches?.[0] || event.originalEvent.touches[0]
        xDown = touch.clientX
        yDown = touch.clientY
        touchStartTime = Date.now()
      })

      $(calendar).on('touchmove', (event) => {
        event.preventDefault()
        endCoords = event.originalEvent.targetTouches[0]

        let xUp = event.touches[0].clientX

        DS = Math.sqrt(xDown * xDown + xUp * xUp)

        prevXdiff = xDiff
        xDiff = xDown - xUp

        swipeDiff = 9
        const currentRight = parseInt($(calendar).css('right'))

        if (Math.abs(xDiff)) {
          if (prevXdiff < xDiff) {
            let newRight = currentRight + swipeDiff
            const maxRight = RIGHT_RANGE + 16
            $(calendar).css({
              right: Math.min(newRight, maxRight)
            })
          } else {
            let newRight = currentRight - swipeDiff
            $(calendar).css({
              right: Math.max(newRight, 0)
            })
          }
        }
      })

      $(calendar).on('touchend', (event) => {
        touchEndTime = Date.now()
        DT = touchEndTime - touchStartTime
        V = DS / DT
        swipeDiff = DS
        let multipleCoef = 300 * V
        let bezEasyCoefs = [.41, .58, .58, 1]

        const currentRight = parseInt($(calendar).css('right'))
        const maxRight = RIGHT_RANGE + 16
        const easingOptions = { duration: ANIMATE_DURATION_SWIPE, easing: $.bez(bezEasyCoefs) }

        if (prevXdiff < xDiff && V > 2) {
          const newRight = currentRight + swipeDiff + multipleCoef
          $(calendar).animate({ right: Math.min(newRight, maxRight) }, easingOptions)

        } else if (V > 2) {
          const newRight = currentRight - swipeDiff - multipleCoef
          $(calendar).animate({ right: Math.max(newRight, 0) }, easingOptions)
        }
      })
    }
  }
}

// Sets the homepage grid's hidden dateFrom/dateTo inputs and submits its htmx filter form -
// the same mechanism as any other filter change (see frontend/views/listing/_grid.php,
// frontend/web/resources/source/js/htmxListing.js), so pagination/other filters and the URL
// bar (hx-push-url) stay in sync automatically. Used by both the mini and horizontal calendar.
function submitHomeGridDateFilter (dateFrom, dateTo) {
  const form = document.getElementById('home-grid-filter')
  if (!form) {
    return
  }
  form.querySelector('[name="dateFrom"]').value = dateFrom || ''
  form.querySelector('[name="dateTo"]').value = dateTo || ''
  form.requestSubmit()
}

document.addEventListener('DOMContentLoaded', function () {
  let calendar = document.getElementById('calendar')

  if (calendar) {
    horizontalCalendarModule.createCalendar(calendar)
    horizontalCalendarModule.init()
    horizontalCalendarModule.initAllDaysFromApi()
  }
})
